import type { CollaborationRequestVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveCollaborationRequestList = createApiThunk<CollaborationRequestVM[], void>(
  "collaborationRequests/retrieveCollaborationRequestList",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.listCollaborationRequests();
  },
);
